import React from 'react'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { Collapse } from 'antd'
import { CLAIM_CENTER_AUTO_DAMAGE_FAQ } from '../constants'

import ClaimsStyle from '../../styles/ClaimsCenter.module.css'

const { Panel } = Collapse

const FAQAutoDamage = () => {
  const executeScroll = key => {
    const element = document.getElementsByClassName(`faq-panel-Auto-Damage_${key}`)
    if (element && element.length > 0) {
      element[0].scrollIntoView({ behavior: 'smooth' })
    }
  }
  return (
    <Collapse
      accordion
      className={`faq-container-Auto-Damage ${ClaimsStyle["p-margin-bottom-15"]}`}
      expandIcon={({ isActive }) => (isActive ? <CaretUpOutlined /> : <CaretDownOutlined />)}
      expandIconPosition="right"
      onChange={key => window.setTimeout(() => executeScroll(key), 500)}
    >
      {CLAIM_CENTER_AUTO_DAMAGE_FAQ.map((item, index) => (
        <Panel
          key={index}
          className={`faq-panel-Auto-Damage faq-panel-Auto-Damage_${index}`}
          header={item.question}
          style={{ fontSize: '1.2rem' }}
        >
          <div className={`${ClaimsStyle["faq-panel-Auto-Damage-text-content"]}`}>
            <div dangerouslySetInnerHTML={{ __html: item.answer }} />
          </div>
        </Panel>
      ))}
    </Collapse>
  )
}

export default FAQAutoDamage
